// extracted by css-extract-rspack-plugin
export default {"version":"lUgFYh9eI_VYaXon","error":"Msm9J14t44lqMd9w"};